<script>
import PreChatFormSettings from '../PreChatForm/Settings.vue';

export default {
  name: 'TicketFormSettings',
  components: { PreChatFormSettings },
  props: {
    inbox: { type: Object, default: () => ({}) },
  },
};
</script>

<template>
  <PreChatFormSettings :inbox="inbox" mode="ticket" />
</template>
